/* eslint-disable prettier/prettier */
/* This file is automatically generated by the plugin 'request-plugin'. Please do not modify. */

import axios from 'axios';

export const instances = {
  DEFAULT: axios.create({ baseURL: 'https://chatapi.halochat.io' }),
  WS: axios.create({ baseURL: 'wss://chatapi.halochat.io' }),
}

export default Object.assign(instances.DEFAULT, instances);